import React from 'react';

import { Alert, Group } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { WHITEBOARD_SIZES } from 'components/Workout/whiteboardDisplay';
import ReadonlyWorkoutNotesRTE from 'components/workout-program/ReadonlyWorkoutNotesRTE';

interface PreviewAthleteNotesProps {
  notes: string;
  enlarged?: boolean;
}

const PreviewAthleteNotes = ({ notes, enlarged = false }: PreviewAthleteNotesProps): JSX.Element => (
  <Alert
    icon={enlarged ? undefined : <IconInfoCircle size={18} />}
    title={
      enlarged ? (
        <Group spacing={8} align='center' noWrap>
          <IconInfoCircle size={WHITEBOARD_SIZES.notesIcon} />
          <span style={{ fontSize: WHITEBOARD_SIZES.notesTitle }}>Athlete Notes</span>
        </Group>
      ) : (
        'Athlete Notes'
      )
    }
    color='blue'
    variant='light'
  >
    <ReadonlyWorkoutNotesRTE
      workoutNotes={notes}
      mih={0}
      bordered={false}
      fontSize={enlarged ? WHITEBOARD_SIZES.bodyText : undefined}
    />
  </Alert>
);

export default PreviewAthleteNotes;
